import { StyledRow } from "App/global-style";
import { formatToLocaleString } from "Formatting/formatNumber";
import { ADVICE_NAMES } from "Store/advice/interfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { replacePlaceholder } from "Utils/replacePlaceholder";
import React from "react";
import { UwInlineAlert } from "./styled";
import { AdviceRestrictions } from "./utils";

interface Props {
  insuranceName: ADVICE_NAMES;
  sliderValue: number;
  restrictions: AdviceRestrictions;
  uwInfoTexts: any;
  lang: string;
}

export const AdvisorUwInfo = ({
  insuranceName,
  sliderValue,
  restrictions,
  uwInfoTexts,
  lang,
}: Props): React.ReactElement | null => {
  if (insuranceName === INSURANCE_NAME_VALUE.DISABILITY_FLEX) {
    const hasExceededMaxValueForNormalAdvisor =
      sliderValue > restrictions.maxAdvisor &&
      sliderValue <= restrictions.maxAuthorizedAdvisor;
    const hasExceededMaxValueForAuthorizedAdvisor =
      sliderValue > restrictions.maxAuthorizedAdvisor &&
      sliderValue <= restrictions.maxProductManager;
    return (
      <>
        {hasExceededMaxValueForNormalAdvisor && (
          <StyledRow>
            <UwInlineAlert
              title={replacePlaceholder(
                uwInfoTexts.disabilityFlex.hasExceededMaxValueForNormalAdvisor[
                  lang
                ],
                {
                  value: formatToLocaleString(restrictions.maxAdvisor),
                },
              )}
            />
          </StyledRow>
        )}
        {hasExceededMaxValueForAuthorizedAdvisor && (
          <>
            <StyledRow>
              <UwInlineAlert
                title={replacePlaceholder(
                  uwInfoTexts.disabilityFlex
                    .hasExceededMaxValueForAuthorizedAdvisor[lang],
                  {
                    value: formatToLocaleString(
                      restrictions.maxAuthorizedAdvisor,
                    ),
                  },
                )}
              />
            </StyledRow>
            <StyledRow>
              <UwInlineAlert
                type="warning"
                title={replacePlaceholder(
                  uwInfoTexts.disabilityFlex
                    .hasExceededMaxValueForAuthorizedAdvisorUW[lang],
                  {
                    value: formatToLocaleString(
                      restrictions.maxAuthorizedAdvisor,
                    ),
                  },
                )}
              />
            </StyledRow>
          </>
        )}
      </>
    );
  } else if (insuranceName === INSURANCE_NAME_VALUE.DEATH) {
    const hasExceededMaxValueForAuthorizedAdvisor =
      sliderValue > restrictions.maxAuthorizedAdvisor &&
      sliderValue <= restrictions.maxProductManager;
    return (
      <>
        {hasExceededMaxValueForAuthorizedAdvisor && (
          <>
            <StyledRow>
              <UwInlineAlert
                title={replacePlaceholder(
                  uwInfoTexts.death.hasExceededMaxValueForAuthorizedAdvisor[
                    lang
                  ],
                  {
                    value: String(
                      restrictions.maxAuthorizedAdvisor / 1_000_000,
                    ),
                  },
                )}
              />
            </StyledRow>
            <StyledRow>
              <UwInlineAlert
                type="warning"
                title={replacePlaceholder(
                  uwInfoTexts.death.hasExceededMaxValueForAuthorizedAdvisorUW[
                    lang
                  ],
                  {
                    value: String(
                      restrictions.maxAuthorizedAdvisor / 1_000_000,
                    ),
                  },
                )}
              />
            </StyledRow>
          </>
        )}
      </>
    );
  }

  return null;
};
